
import { Link } from 'react-router-dom';

export default function Footer() {
  const currentYear = new Date().getFullYear();

  const handleLinkClick = (path: string) => {
    if (path.startsWith('/#')) {
      const sectionId = path.substring(2);
      const element = document.getElementById(sectionId);
      if (element) {
        element.scrollIntoView({ behavior: 'smooth' });
      }
    } else if (path === '/') {
      window.scrollTo({ top: 0, behavior: 'smooth' });
    }
  };

  return (
    <footer className="bg-gray-900 text-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {/* 会社情報 */}
          <div className="col-span-1 md:col-span-2">
            <h3 className="text-xl font-bold mb-4" style={{ fontFamily: '"Pacifico", serif' }}>
              整骨院
            </h3>
            <p className="text-gray-300 mb-4">
              地域の皆様の健康をサポートする整骨院です。<br />
              経験豊富なスタッフが丁寧に施術いたします。
            </p>
            <div className="space-y-2 text-gray-300">
              <p><i className="ri-map-pin-line mr-2"></i>〒123-4567 東京都渋谷区○○町1-2-3</p>
              <p><i className="ri-phone-line mr-2"></i>〇〇〇-□□□□-××××</p>
              <p><i className="ri-time-line mr-2"></i>平日 9:00-20:00 / 土日 9:00-18:00</p>
            </div>
          </div>

          {/* メニュー */}
          <div>
            <h4 className="text-lg font-semibold mb-4">メニュー</h4>
            <ul className="space-y-2">
              <li>
                <button
                  onClick={() => handleLinkClick('/')}
                  className="text-gray-300 hover:text-white transition-colors cursor-pointer text-left"
                >
                  ホーム
                </button>
              </li>
              <li>
                <button
                  onClick={() => handleLinkClick('/#about')}
                  className="text-gray-300 hover:text-white transition-colors cursor-pointer text-left"
                >
                  当院について
                </button>
              </li>
              <li>
                <button
                  onClick={() => handleLinkClick('/#services')}
                  className="text-gray-300 hover:text-white transition-colors cursor-pointer text-left"
                >
                  診療メニュー
                </button>
              </li>
              <li>
                <button
                  onClick={() => handleLinkClick('/#testimonials')}
                  className="text-gray-300 hover:text-white transition-colors cursor-pointer text-left"
                >
                  お客様の声
                </button>
              </li>
              <li>
                <button
                  onClick={() => handleLinkClick('/#recruitment')}
                  className="text-gray-300 hover:text-white transition-colors cursor-pointer text-left"
                >
                  求人情報
                </button>
              </li>
              <li>
                <button
                  onClick={() => handleLinkClick('/#contact')}
                  className="text-gray-300 hover:text-white transition-colors cursor-pointer text-left"
                >
                  お問い合わせ
                </button>
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-gray-700 mt-8 pt-8 flex flex-col sm:flex-row justify-between items-center">
          <p className="text-gray-400 text-sm">
            © {currentYear} 整骨院. All rights reserved.
          </p>
          <div className="mt-4 sm:mt-0">
            <a 
              href="https://readdy.ai/?origin=logo" 
              target="_blank" 
              rel="noopener noreferrer"
              className="text-gray-400 hover:text-white text-sm transition-colors cursor-pointer"
            >
              Website Builder
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}
